import { createRootRoute, Outlet } from '@tanstack/react-router';
import { useLogoutSync } from '@/features/login/hooks/useLogoutSync';
import { useSistemaQuery } from '@/features/sistema/api';
import { CarregandoSistema } from '@/router/CarregandoSistema';
import { RouterProgress } from '@/router/RouterProgress';

function Root() {
    useLogoutSync();
    const { sistema } = useSistemaQuery();

    if (!sistema) {
        return <CarregandoSistema />;
    }

    return (
        <>
            <RouterProgress />
            <Outlet />
        </>
    );
}

export const Route = createRootRoute({ component: Root });
